import { render, staticRenderFns } from "./CompanyFinanceInvoiceTemplateConstructor.vue?vue&type=template&id=0b234672&scoped=true&"
import script from "./CompanyFinanceInvoiceTemplateConstructor.vue?vue&type=script&lang=js&"
export * from "./CompanyFinanceInvoiceTemplateConstructor.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFinanceInvoiceTemplateConstructor.vue?vue&type=style&index=0&id=0b234672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b234672",
  null
  
)

export default component.exports